var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFavIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 106.459,
    height: 99.361,
    viewBox: "0 0 106.459 99.361",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_12712",
    "data-name": "Path 12712",
    d: "M106.458,29.87v4.22a6.651,6.651,0,0,0-.162.816,39.885,39.885,0,0,1-4.945,16.059A84.331,84.331,0,0,1,87.506,69.2C77.872,79.238,67.439,88.4,57.024,97.57c-2.71,2.388-4.936,2.4-7.646-.028-8.37-7.485-16.755-14.954-25.065-22.508a107.494,107.494,0,0,1-15.837-17.4A43.534,43.534,0,0,1,.034,33.912C-.35,24.364,2.486,15.992,9.22,9.243a31.527,31.527,0,0,1,37.3-5.37c2.336,1.27,4.519,2.831,6.872,4.321.21-.161.563-.435.921-.7C65.329-.737,77.13-2.457,89.56,3.679c8.073,3.985,13.235,10.707,15.655,19.489.6,2.181.839,4.466,1.243,6.7",
    transform: "translate(0 0)",
    fill: "#ffa76c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavIcon);
export default __webpack_public_path__ + "static/media/favIcon.0a5e8c58e31d75635e33f88e9e11c242.svg";
export { ForwardRef as ReactComponent };